import React, { useEffect, useState } from "react";
import {
    Row,
    Col,
    Button,
    notification,
    Form,
    Input,
    Select,
    DatePicker,
} from "antd";
import axios from "axios";
import { CalendarOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useHistory } from "react-router-dom";
import { baseUrl } from "../../config";

const { Item } = Form;
const { Option } = Select;
const { TextArea } = Input;

function StaffForm({userId, onRefreshData = () => {}}) {

   
   // const { id } = useParams(); // Extract id from URL
    const history = useHistory();
    const [form] = Form.useForm();
    const [isUpdateMode, setIsUpdateMode] = useState(false);  
    const [txnDate, setTxnDate] = useState();
  

    useEffect(() => {
        // Check if id exists to determine if it's an update mode
        if (userId) {
            setIsUpdateMode(true);
            fetchRoleDetails();
        }
    }, [userId]);


    const fetchRoleDetails = async () => {
        try {
            const response = await axios.get(`${baseUrl}/registration/read/${userId}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`, // Include access token in headers
                },
            });
            if (response.status === 200) {
                // setRoleData(response.data.result);
                form.setFieldsValue(response.data.result); // Populate form fields with fetched data
                setTxnDate(response.data.result.dob ? response.data.result.dob : null) // Format the date if present)
                
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } catch (error) {
            console.error("API error:", error);
            notification.info({
                message: 'Info',
                description: error.response?.data?.message,
                placement: 'topRight'
            });
        }
    };


    // Fixed StaffForm.js - onFinish method
const onFinish = async (values) => {
    try {
        // ✅ Fix: Proper date handling - send null instead of empty strings
        if (txnDate && txnDate !== '0000-00-00' && moment(txnDate).isValid()) {
            const formattedDate = moment(txnDate).format('YYYY-MM-DD');
            values.dob = formattedDate;
        }
        // Don't set dob if it's empty/invalid

        if (isUpdateMode) {
            const response = await axios.patch(`${baseUrl}/registration/update/${userId}`, values, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            if (response.status === 200) {
                notification.success({
                    message: 'Success',
                    description: 'Record updated successfully!',
                    placement: 'topRight'
                });
                onRefreshData();
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        } else {
            const response = await axios.post(`${baseUrl}/registration/create`, values, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                },
            });
            if (response.status === 200) {
                notification.success({
                    message: 'Success',
                    description: 'Registration added successfully!',
                    placement: 'topRight'
                });
                form.resetFields();
                onRefreshData();
            } else {
                notification.info({
                    message: 'Info',
                    description: response.data.message,
                    placement: 'topRight'
                });
            }
        }
    } catch (error) {
        console.error("API error:", error);
        notification.error({
            message: 'Error',
            description: error.response?.data?.message || 'Operation failed',
            placement: 'topRight'
        });
    }
};

  

    const handleDateChange = (date, dateString) => {
        if (date) {
            const formattedDate = moment(date).format('YYYY-MM-DD');
            setTxnDate(formattedDate)
        } else {
            setTxnDate(null);
        }
    };



    return (
        <div>
            <Form style={{ padding: "4px" }} form={form} onFinish={onFinish} layout="vertical">
                <div style={{ fontSize: "11px", fontWeight: 700, color: "#888", letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "16px", borderBottom: "1px solid #e8e8e8", paddingBottom: "8px" }}>
                    REGISTRATION DETAILS
                </div>
                <Row gutter={[24, 0]}>
                <Col xs="24" xl={24}>
                    <div>
                            <Row gutter={[16, 16]}>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item
                                        label="Phone No"
                                        name="phone_no"
                                        rules={[{ required: true, message: 'Please Enter Phone no' },
                                            { pattern: /^\d{10,12}$/, message: 'Phone no must be between 10 and 12 digits!' }
                                        ]}
                                    >
                                        <Input type="number" placeholder="Enter Phone no" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Name" name="name" rules={[{ required: true, message: 'Please Enter Name' }]}>
                                        <Input placeholder="Enter Name" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Father Name" name="father_name">
                                        <Input placeholder="Enter Father Name" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Village" name="village">
                                        <Input placeholder="Enter Village" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="District" name="district">
                                        <Input placeholder="Enter District" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Occ Address" name="occ_address">
                                        <Input placeholder="Enter Occ Address" />
                                    </Item>
                                </Col>

                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Amount" name="amount">
                                        <Input type="number" placeholder="Enter Amount" />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="DOB">
                                        <DatePicker onChange={handleDateChange} value={txnDate && txnDate !== "0000-00-00" && moment(txnDate)} className="filter_dob" format="DD-MM-YYYY" placeholder="Select DOB" style={{ width: "100%" }} />
                                    </Item>
                                </Col>
                                <Col xs={24} sm={12} lg={8}>
                                    <Item label="Payment Status" name="payment_status">
                                        <Select placeholder="Payment Status">
                                            <Option value="Pending">Pending</Option>
                                            <Option value="Received">Received</Option>
                                        </Select>
                                    </Item>
                                </Col>

                                <Col xs={24} sm={24} lg={24}>
                                    <Item label="Remark" name="remark">
                                        <TextArea placeholder="Enter Remark" rows={2} />
                                    </Item>
                                </Col>

                            </Row>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #e8e8e8" }}>
                                <Button onClick={() => onRefreshData()} style={{ borderRadius: 8, borderColor: '#7a0000', color: '#7a0000' }}>
                                    Cancel
                                </Button>
                                <Button type="primary" htmlType="submit" style={{ background: '#7a0000', borderColor: '#7a0000', borderRadius: 8 }}>
                                    {isUpdateMode ? "Update" : "Save"}
                                </Button>
                            </div>

                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    );
}

export default StaffForm;
